import React from "react";
import { HStack, Stack } from "@chakra-ui/react";
import { LibraryAndArchive } from "./ResearchCentre/LibraryAndArchive";

const Carousel = ({ data, searchsTerm, allCount, setAllCount }) => {
  return (
    <HStack py={0}>
      <Stack width={"100%"} position={"relative"} id="allslider">
        {data &&
          <>
            <Stack>
              {data?.index==="Research Centre" && (
                <LibraryAndArchive 
                  masterlist={searchsTerm} 
                  SearchTerm={searchsTerm} 
                  setAllCount={setAllCount} 
                  allCount={allCount}
                />
              )}
            </Stack>
          </>
        }
      </Stack>
    </HStack>
  );
};

export default Carousel;

